module.exports = __webpack_public_path__ + "static/img/modeling.774caf12.png";